import { render, staticRenderFns } from "./JobListingDetails.vue?vue&type=template&id=12c9c9bf&scoped=true"
import script from "./JobListingDetails.vue?vue&type=script&lang=js"
export * from "./JobListingDetails.vue?vue&type=script&lang=js"
import style0 from "./JobListingDetails.vue?vue&type=style&index=0&id=12c9c9bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9c9bf",
  null
  
)

export default component.exports